import styled from 'styled-components';

export const Icon = styled.img`
  width: 100px;
  height: auto;
  margin: 56px auto 65px;
`;

export const Content = styled.p`
  font-size: 16px;
  line-height: 1.31;
  text-align: center;
  color: #737373;
`;